<!-- <app-loader *ngIf="showSpinner"></app-loader> -->
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="container-fluid mb-4">
    <div class="evaluation-summary-header">
      <div class="row">
        <div class="col-md-4">
          <div class="evaluation-header-left" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
            <h1>SUMMARY <span>{{evaluation.month_char}} {{evaluation.month_year}}</span></h1>
          </div>
        </div>
        <div class="col-md-8">
          <div class="report-inner-section px-2 px-sm-4 py-3">
            <div class="report-inner-right-tag" id="evaluation-zero-hide">
              <div class="d-flex">
                <div class="inner-left-tag">
                  <img src="../../../assets/images/tag-icon.svg" alt="">
                </div>
                <div class="inner-left-tag-content" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
                  <h1>{{ user.first_name }} is a brilliant
                  employee of the month.</h1>
                </div>
              </div>

              <div class="inner-right-tag-content" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
                <h1>{{ evaluation.pm_points
                  }} <span>OUT OF 10</span></h1>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="evaluation-summary-table">
        <div class="row">
          <div class="col-md-8">
            <div class="attendance-report-table mt-3">
              <div class="attendance-report-table-header d-flex justify-content-around pl-3 pr-0">
                <div class="table-heading evaluation-table-heading ">KP Description</div>
                <div class="table-heading evaluation-table-heading text-center">KP Values</div>
                @if (this.currentUrl === 'evaluation-list') {
                  <div class="table-heading evaluation-table-heading text-center">TL Rating</div>
                }
                @if (this.currentUrl === 'evaluation-list') {
                  <div class="table-heading evaluation-table-heading text-center" >PM Rating</div>
                }
                @if (this.currentUrl === 'evaluation') {
                  <div class="table-heading evaluation-table-heading text-center">Rating</div>
                }


              </div>


              @for (item of KPValues; track item; let i = $index) {
                <div class="attendance-report-table-body d-flex justify-content-around pl-3 my-4 my-md-0 py-4 py-md-0 pr-0" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                  <div class="table-cotent evaluation-table-cotent">
                    <div class="table-content-heading"><h1>KP Description</h1></div>
                    <div class="table-content-value evaluation-table-content-value">
                      <h1>{{item.title}}</h1>
                    </div>
                  </div>
                  <div class="table-cotent evaluation-table-cotent">
                    <div class="table-content-heading"><h1>KP Values</h1></div>
                    <div class="table-content-value evaluation-table-content-value text-md-center" ><h1>{{item.value}}</h1></div>
                  </div>
                  @if (this.currentUrl === 'evaluation-list') {
                    <div class="table-cotent evaluation-table-cotent">
                      <div class="table-content-heading"><h1>TL Rating</h1></div>
                      <div class="table-content-value evaluation-table-content-value text-md-center" ><h1>{{evaluationPoints[i]}}</h1></div>
                    </div>
                  }
                  <div class="table-cotent evaluation-table-cotent" >
                    <div class="table-content-heading"><h1>PM Rating</h1></div>
                    <div class="table-content-value evaluation-table-content-value text-md-center" ><h1>{{P_M_evaluationPoints[i]}}</h1></div>
                  </div>
                </div>
              }
              <div class="attendance-report-table-body total-evaluation d-flex justify-content-around pl-3 my-4 my-md-0 py-4 py-md-0 pr-0" [ngClass]="{ 'dark-total-backround': selectedMode === 'dark' }">

                <div class="table-content-value evaluation-table-content-value text-center text-md-left">
                  <h1>Total</h1>
                </div>




                <div class="table-content-value evaluation-table-content-value text-center" ><h1>100</h1></div>




                <div class="table-content-value evaluation-table-content-value text-center" ><h1>{{totalRating}}</h1></div>
                <div class="table-content-value evaluation-table-content-value text-center" ><h1>{{totalRating1}}</h1></div>



              </div>


            </div>
          </div>
          <div class="col-xl-4 col-sm-12 col-12" style="margin-top: 18px">
            <div class="card">
              <div class="card-content rounded">
                <div class="card-body rounded-top" style="background-color: #7cdb80" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                  <div
                    class="media text-center text-white font-weight-normal"
                    style="font-size: 20px"
                    >
                    <div class="col">
                      <span class="text float-left">Band Range</span>
                      <span class="text float-right">Band Value</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <table class="table table-bordered" [ngClass]="{ 'dark-backround-tr': selectedMode === 'dark' }">
              <thead>
                <tr [ngClass]="{'bandColor': band1}">
                  <th>0%-25%</th>
                  <td>1</td>
                </tr>
              </thead>
              <tbody>
                <tr [ngClass]="{'bandColor': band2}">
                  <th>25%-50%</th>
                  <td>2</td>
                </tr>
                <tr [ngClass]="{'bandColor': band3}">
                  <th>50%-75%</th>
                  <td>3</td>
                </tr>
                <tr [ngClass]="{'bandColor': band4}">
                  <th>75%-100%</th>
                  <td>4</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>


    </div>
    @if (showSpinner) {
      <app-loader> </app-loader>
    }
  </main>